import { queryCommonFlags } from "@/api/constants";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from '@tanstack/react-query';
import { getMethodsOfContact } from "@/modules/lead-page/api/lead-page.v2.api";
import { UUID } from "crypto";

const useEditMethodOfContact = () => {
  const { lead } = useContext(LeadPageContext);

  const value = useMemo(() => {
    return lead?.data?.lead?.method_of_contact?.name || "";
  }, [lead]);

  const [methodOfContactSearch, setMethodOfContactSearch] = useState("");
  const [selectedMethodOfContactPartner, setSelectedMethodOfContactPartner] =
    useState<UUID | null>(null);
  const [methodOfContactId, setMethodOfContactId] = useState<UUID | null>(null);
  const [editMethodOfContactModalOpen, setEditMethodOfContactModalOpen] =
    useState(false);
  const methodsOfContact = useQuery({
    queryKey: ["getMethodOfContacts", methodOfContactSearch],
    queryFn: async ({ signal }) =>
      await getMethodsOfContact({
        params: {
          page: 1,
          pageSize: 50,
          organizationUId: lead?.data?.lead?.organization?.uid,
          ...(methodOfContactSearch && { name: methodOfContactSearch }),
        },
        signal,
      }),
    enabled: editMethodOfContactModalOpen,
    ...queryCommonFlags,
    staleTime: Infinity,
  });

  const handleChangeMethodOfContact = (value: UUID | undefined) => {
    setMethodOfContactId(value ?? null);
  };

  useEffect(() => {
    if (value !== null && value !== undefined) {
      setMethodOfContactSearch(value);
    }
  }, [value]);

  return {
    methodOfContact: {
      editMethodOfContactModalOpen,
      setEditMethodOfContactModalOpen,
      selectedMethodOfContactPartner,
      setSelectedMethodOfContactPartner,
      handleChangeMethodOfContact,
      value: lead?.data?.lead?.method_of_contact?.name || "",
      initialMethodOfContactId: lead?.data?.lead?.method_of_contact?.id,
      state: methodOfContactId,
      setState: setMethodOfContactId,
      search: methodOfContactSearch,
      setSearch: setMethodOfContactSearch,
      data: methodsOfContact,
      isLoading: methodsOfContact.isLoading,
    },
  };
};

export default useEditMethodOfContact;
